import {
    FormControlLabel,
    Checkbox,
    makeStyles,
    createStyles,
    Theme
} from '@material-ui/core'

export type UnitsType = {
    label: string;
    checked: boolean;
    mandatory: boolean;
    key: string;
}
type SelectFacilitiesType = {
    units: UnitsType[],
    initialUnits: UnitsType[],
    setUnits: (changedUnits: UnitsType[]) => void,
    handleSave?: (units: UnitsType[]) => void
}
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        facilitiesLabel: {
            width: "45%",
            [theme.breakpoints.down("xs")]: {
                width: "100%",
            },
        },
        marginLabel: {
            marginBottom: "18px",
        },
    }),
);

export const SelectFacilities = ({ units, setUnits, handleSave, initialUnits }: SelectFacilitiesType) => {
    const styles = useStyles();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let changedUnits: UnitsType[] = [...initialUnits]
        let unitIndex = changedUnits.findIndex((item: UnitsType) => item.label === e.target.name)
        changedUnits[unitIndex].checked = e.target.checked
        if (handleSave) {
            handleSave(changedUnits)
        }
        setUnits(changedUnits)
    }
    return <>
        {units.map((item, index) => {
            return (
                <FormControlLabel
                    className={styles.facilitiesLabel}
                    key={index}
                    onClick={(event) => event.stopPropagation()}
                    onFocus={(event) => event.stopPropagation()}
                    disabled={item.mandatory}
                    control={
                        <Checkbox
                            checked={item.checked}
                            onChange={handleChange}
                            name={item.label}
                        />
                    }
                    label={item.label}
                />
            )
        })}
    </>
}
